import { useCallback } from 'react';

import { useAnalytics } from './useAnalytics';

export function useOnboardingPeriodAnalytics(onboardingPeriodId?: string) {
  const { sendEvent } = useAnalytics();

  const track = useCallback(
    (name: string, payload?: object) =>
      void sendEvent(name, {
        onboarding_period_id: onboardingPeriodId,
        ...payload,
      }),
    [sendEvent, onboardingPeriodId]
  );

  return { track };
}
